module.exports = __webpack_public_path__ + "static/media/Greninja_gaussian2.d094ce5b.png";